exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#show-material-requirements .modal-dialog{max-width:960px}", ""]);

// exports
